import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetListProvidersModel,
	GetProvidersList,
	GetProvidersListParams,
} from 'domain/usecases/private/authorizations/get-providers-list';

export class RemoteGetProvidersList implements GetProvidersList {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetListProvidersModel>,
	) {}

	async get(params: GetProvidersListParams): Promise<GetListProvidersModel> {
		const {signal, ...restParams} = params || {};

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: restParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
